var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{ref:"selectBoxRef",attrs:{"options":_vm.orgData,"show-all-levels":false,"placeholder":"请选择所属网格","disabled":_vm.disabled,"clearable":"","props":{ checkStrictly: true }},on:{"change":_vm.handleEditNodeClick},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }